import type { TransitionMeetingManageResource } from "api/generated";
import type { TransitionMeetingManage } from "meetings/advisory/types";
import { answerOptionFromDto, answerTypeFromDto } from "./answerOption.mapper";
import { teacherScoreFromDto } from "./teacherScore.mapper";
import { timeframeSettingsFromDto } from "./timeframe.mapper";

export const meetingManageFromDto = (
  dto: TransitionMeetingManageResource,
): TransitionMeetingManage => ({
  id: dto.id,
  schoolId: dto.school_id,
  schoolYear: dto.school_year,
  name: dto.name,
  status: dto.status as TransitionMeetingManage["status"],
  message: dto.message,
  allowGrades: dto.allow_grades,
  answerType: answerTypeFromDto(dto.answer_type),
  answerOptions: dto.answer_options.map(answerOptionFromDto),
  questionPrompt: dto.question_prompt,
  inProgress: dto.in_progress,
  totalRatings: dto.total_ratings,
  totalGivenRatings: dto.total_given_ratings,
  schedules: dto.schedules,
  studentIds: dto.student_ids,
  ratedSchedules: dto.rated_schedules,
  teacherScores: dto.teacher_scores.map(teacherScoreFromDto),
  timeframeSettings: timeframeSettingsFromDto(dto.timeframe_settings),
  meta: {
    canUpdateAnswerConfig: dto.meta.can_update_answer_config,
  },
});
